const config = {
    API_URL:
      process.env.NODE_ENV === 'production'
        ? 'https://admin.jra.tools'
        : 'http://localhost:4000',
  }
  
  export default config